/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

//Imposto l'url de lsito per le chiamate ajax
var site_url = document.location.protocol + '//' + document.location.host;

(function ($) {

    // require('fancybox')($); 

    function goToByScroll(id) {
        id = id.replace("link", "");
        // Scroll
        $('html,body').animate({
                scrollTop: $("#" + id).offset().top - 100
            },
            'slow');
    }

    function showBodyOverlay()
    {
        var $bodyOverlay = $("#body-overlay").first();
        if ($bodyOverlay.length === 0) {
            $bodyOverlay = $("<div id='body-overlay'>");
            $("body").append($bodyOverlay);
        }
        $bodyOverlay.css("display", "block");
    }

    function hideBodyOverlay()
    {
        $("#body-overlay").remove();
    }

    // Use this variable to set up the common and page specific functions. If you
    // rename this variable, you will also need to rename the namespace below.
    var Sage = {
        'login': {
            init: function () {

            },
            finalize: function () {

            }
        },

        'registration_base': {
            init: function () {
                $("select[name=category]").change(function () {
                    var selectedValue = $(this).val();
                    $("*[data-category]").each(function () {
                        var $this = $(this);
                        if ($(this).data("category") === selectedValue) {
                            $this.show();
                        } else {
                            $this.hide();
                        }
                    });
                });
                $("select[name=country]").change(function () {
                    var selectedValue = $(this).val();
                    $("*[data-country]").each(function () {
                        var $this = $(this),
                            show = false;
                        if ($(this).data("country") === "Italy") {
                            show = ("Italy" === selectedValue);
                        } else if ($(this).data("country") === "Not-Italy") {
                            show = ("" !== selectedValue && "Italy" !== selectedValue);
                        }
                        if (show) {
                            $this.show();
                        } else {
                            $this.hide();
                        }
                    });
                });
            },
        },

        "user_registration": {
            init: function () {

            },
            finalize: function () {
                $(document).on("change", "#type-altro", function () {
                    var $typeAltroText = $("input[name='type-altro-text']");
                    if (this.checked) {
                        $typeAltroText.show();
                    } else {
                        $typeAltroText.val("").hide();
                    }
                });
                $(document).on("change", "#type-why-altro", function () {
                    var $typeWhyAltroText = $("input[name='type-why-altro-text']");
                    if (this.checked) {
                        $typeWhyAltroText.show();
                    } else {
                        $typeWhyAltroText.val("").hide();
                    }
                });
            }
        },

        'home': {
            init: function () {

            },
            finalize: function () {

            }
        },

        'common': {
            init: function () {

                function xxx() {
                    var win_w = window.innerWidth,
                        $body = $('body'),
                        $nx_primary = $('#nx_primary_menu'),
                        $nav_account = $('ul.nav.navbar-account'),
                        $primary_superior = $('.navbar-primary-superior'),
                        $nav_lang = $(".navbar-lang"),
                        $nav_sections = $(".navbar-sections");

                    if (win_w < 992) {
                        if (!$body.hasClass('mobile')) {
                            $body.addClass('mobile');
                            $nav_account.detach().appendTo($nx_primary);

                            $nav_sections.detach().insertAfter($primary_superior);
                            $nav_lang.detach().appendTo($nx_primary);
                        }

                    } else {
                        if ($body.hasClass('mobile')) {
                            $body.removeClass('mobile');
                            $nav_account.detach().insertAfter($primary_superior);

                            $nav_sections.detach().insertAfter($nx_primary);
                            $nav_lang.detach().insertAfter($nx_primary);

                        }
                    }
                }

                xxx();
                $(window).resize(function () {
                    xxx();
                });

                $('[data-show]').change(function (e) {
                    var target = $(this).data('show');
                    var targets = target.split(' ');

                    for (var i = 0; i < targets.length; i++) {
                        $('#' + targets[i]).slideToggle();
                    }
                });

                $('[data-switcher]').change(function (e) {
                    var value = $(this).val();
                    var target = $(this).data('switcher');

                    $('[data-switch=' + target + ']').slideUp();
                    $('[data-switch-id=' + value + ']').slideDown();
                });

                $('[data-file-name-target]').change(function () {
                    var target = $(this).data('file-name-target');
                    $('#' + target).val($(this).val());
                });
                $('[data-file-target]').click(function () {
                    var target = $(this).data('file-target');
                    $('#' + target).click();
                });

                // $('[data-toggle=tooltip]').tooltip();

                var imagesLikes = {
                    // id(int): hasLike(bool)
                };

                $('[data-fancybox=gallery]').fancybox({
                    arrows: true,
                    infobar: false,
                    toolbar: "auto",
                    clickContent: false,
                    buttons: ('boolean' === typeof fancyboxDownloadButton && fancyboxDownloadButton) ? ['download', 'close'] : ['close'],
                    onInit: function () {
                        $(".fancybox-toolbar .fancybox-button--close").removeClass("fancybox-button--close");
                        $(".fancybox-toolbar .fancybox-button--download").click(function (e) {
                            e.preventDefault();
                            var instance = $.fancybox.getInstance(),
                                currentIndex = instance.current.index,
                                $selectedGalleryItem = $(".gallery-item").eq(currentIndex),
                                selectedGalleryItemId = $selectedGalleryItem.attr("data-id");

                            window.open('//' + location.host + "/photogallery/download/image/" + String(selectedGalleryItemId) + "?t=" + (new Date()).getSeconds());
                            return false;
                        });
                    },

                    beforeShow: function (instance, item) {
                        var $fancyboxCaptionWrap = $(".fancybox-caption-wrap"),
                            $fancyboxCaption = $fancyboxCaptionWrap.children(".fancybox-caption");

                        $(".fancybox-caption-wrap").css("visibility", "visible").css("opacity", 1);

                        var $selectedGalleryItem = $(".gallery-item").eq(item.index),
                            selectedGalleryItemId = $selectedGalleryItem.attr("data-id"),
                            selectedGalleryItemHasDoc = parseInt($selectedGalleryItem.attr("data-hasdoc")); // 0|1

                        if (!(selectedGalleryItemId in imagesLikes)) { // la mostro per la prima volta
                            var hasLike = parseInt($selectedGalleryItem.attr("data-haslike")); // 0|1
                            if (isNaN(hasLike)) {
                                hasLike = 0;
                            }
                            imagesLikes[selectedGalleryItemId] = hasLike;
                        } else {
                            // già mostrata
                        }
                        selectedGalleryItemHasLike = imagesLikes[selectedGalleryItemId];

                        if (1 === selectedGalleryItemHasLike) {
                            $fancyboxCaption.html(
                                "<button class='image-liked' data-action='none'><img src='/dist/images/heart-filled.png'> " + fancyboxImageLikeLabel + '</button>'
                            );
                        } else {
                            $fancyboxCaption.html(
                                "<button data-index='" + String(item.index) + "' data-id='" + selectedGalleryItemId + '\' data-action="like"><img src="/dist/images/heart-outline.png"> ' + fancyboxImageLikeLabel + '</button>'
                            );
                        }

                    }
                    /*,
                                       btnTpl: {
                                           // close button
                                           close: '<button data-fancybox-close class="fancybox-button fancybox-button--close" title="{{CLOSE}}">' +
                                           '<span>{{CLOSE}}</span>' +
                                           '<svg viewBox="0 0 40 40">' +
                                           '<path d="M10,10 L30,30 M30,10 L10,30" />' +
                                           '</svg>' +
                                           '</button>',
                                           download: '<button class="fancybox-button" title="{{Download}}">' +
                                               '<span>Download</span>' +
                                               '</button>',
                                           // prev button
                                           arrowLeft: '<button data-fancybox-prev class="fancybox-button fancybox-button--arrow_left" title="{{PREV}}">' +
                                           '<svg viewBox="0 0 50 50">' +
                                           '<polygon fill="#0F2F6C" points="30.929,11 16.333,25 30.929,39 33.667,36.359 21.831,25 33.667,13.641 "/>' +
                                           '</svg>' +
                                           '</button>',
                                           // next button
                                           arrowRight: '<button data-fancybox-next class="fancybox-button fancybox-button--arrow_right" title="{{NEXT}}">' +
                                           '<svg viewBox="0 0 50 50">' +
                                           '<polygon fill="#0F2F6C" points="19.071,39 33.667,25 19.071,11 16.333,13.641 28.169,25 16.333,36.36 "/>' +
                                           '</svg>' +
                                           '</button>'
                                       }*/

                });

                $(document).on("click", ".fancybox-caption button", function () {
                    var $btn = $(this),
                        id = $btn.data("id"),
                        action = $btn.attr("data-action");
                    if ("like" === action) {
                        $.post({
                            url: "/photogallery/image/" + String(id) + "/like",
                            data: {
                                "_token": $("meta[name='_token']").attr("content"),
                            },
                            success: function (response) {
                                if ("success" in response && response.success === 1) {
                                    // $btn.attr("data-action","recipe").html( '<img src="/dist/images/heart-filled.png"> ' + fancyboxImageRecipeLabel );
                                    $btn.attr("data-action", "none").addClass("image-liked").html('<img src="/dist/images/heart-filled.png"> ' + fancyboxImageLikeLabel);
                                    $(".gallery-item").eq(parseInt($btn.data("index"))).attr("data-haslike", "1");
                                    imagesLikes[id] = 1;
                                }
                            },
                            error: function (response, status, error) {
                                console.log('Si &egrave; verificato un errore! Riprova');
                            }
                        });
                    }
                    // else if ("recipe" === action) {
                    //     window.open('//' + location.host + "/photogallery/image/" + String(id) + "/recipe?t=" + (new Date()).getSeconds());
                    // }
                });

                // TODO: spostare tutti i contenitori di errore in testa alla pagina (scorrimento gestito più sotto)
                // /*
                //     Se la pagina ha un messaggio di errore, scrorri la pagina fino a mostrarlo
                //  */
                // var $alertSuccessOrDanger = $(".alert-success, .alert-danger");
                // if ($alertSuccessOrDanger.length > 0) {
                //     window.scrollTo({
                //         top: $alertSuccessOrDanger.first().offset().top - $(".navbar-header").height() - 30,
                //         left: 0,
                //         behavior: 'smooth'
                //     });
                // }

                $("form").submit(function () {
                    showBodyOverlay();
                });

                /*
                    Scorri la pagina fino a sotto l'immagine di testata
                 */
                var $sectionTopImage = $(".section-container.top-image").first();
                if ($sectionTopImage.length === 1) {
                    window.scrollTo({
                        top: $sectionTopImage.height() - 30,
                        left: 0,
                        behavior: "smooth"
                    });
                }

                /*
                    Nuovo header
                 */

                function adjustMenuContentHeight() {
                    $(".header2022-menu").css("max-height",
                        ($(window).height() - $(".header2022-bar").outerHeight()) + "px"
                    );
                }

                $(window).scroll(function () {
                    if ($(this).scrollTop() > 0) {
                        $(".header2022").addClass("small");
                    } else {
                        $(".header2022").removeClass("small");
                    }
                    adjustMenuContentHeight();
                })
                    .scroll();

                $(window).resize(function () {
                    $("body").css("padding-top", $(".header2022-bar").outerHeight() + "px");
                    adjustMenuContentHeight();
                })
                    .resize();

                $(".header2022 .col-menu-button").click(function () {
                    var $this = $(this);
                    if ($this.hasClass("open")) {
                        $this.children("img").first().attr("src", "/dist/images/header-icon-bars-solid.svg");
                        $this.removeClass("open").addClass("close");
                    } else {
                        $this.children("img").first().attr("src", "/dist/images/header-icon-xmark-solid.svg");
                        $this.removeClass("close").addClass("open");
                    }
                });

                $(".header2022-menu")
                    .on("shown.bs.collapse", function () {
                        $("body").css("overflow", "hidden");
                    })
                    .on("hide.bs.collapse", function () {
                        $(this).scrollTop(0);
                    })
                    .on("hidden.bs.collapse", function () {
                        $("body").css("overflow", "auto");
                    });

                $(".subsection-header.with-expand-btn > a").click(function (e) {
                    var windowWidth = $(window).width();
                    if (windowWidth < 768) {
                        e.preventDefault();
                        $(this).next(".expand-btn").click();
                    }
                });
                $(".with-expand-btn > a").click(function (e) {
                    var windowWidth = $(window).width();
                    if (windowWidth >= 768 && windowWidth < 992) {
                        e.preventDefault();
                        $(this).next(".expand-btn").click();
                    }
                });
                $(".with-expand-btn .expand-btn").click(function () {
                    var $this = $(this);
                    $this.toggleClass('open');
                    $this.parent().toggleClass('open');
                    $this.parent().next(".expandable").toggle('fast');
                });
            },
            finalize: function () {
            },
        },

        'data_sheet': {
            init: function () {
                // var $body = $('body'),
                //     $open_mobile = $('span#open_mobile'),
                //     $close_mobile = $('span#close_mobile'),
                //     $datasheet_list = $('nav.datasheet-list'),
                //     $datasheet_item_active = null;
                //
                // $close_mobile.click(function () {
                //     $body.toggleClass('open_cat');
                //     $datasheet_list.toggleClass('open_cat');
                // });
                // $open_mobile.click(function () {
                //     $body.toggleClass('open_cat');
                //     $datasheet_list.toggleClass('open_cat');
                // });
                //
                // function close_datasheet_list_on_mobile() {
                //     var win_w = $(window).innerWidth();
                //     if (win_w >= 768) {
                //         if ($body.hasClass('open_cat')) {
                //             $body.removeClass('open_cat');
                //         }
                //         if ($datasheet_list.hasClass('open_cat')) {
                //             $datasheet_list.removeClass('open_cat');
                //         }
                //     }
                // }
                //
                // close_datasheet_list_on_mobile();
                // $(window).resize(function () {
                //     close_datasheet_list_on_mobile();
                // });
                //
                // $('.datasheet-item').click(function (e) {
                //     e.preventDefault();
                //
                //     if ($datasheet_item_active != null) {
                //         $datasheet_item_active.removeClass("active");
                //     }
                //     $datasheet_item_active = $(this);
                //     $datasheet_item_active.addClass("active");
                //
                //     //Dati
                //     var cat_id = $(this).data('id');
                //     var cat_level = parseInt($(this).data('level'));
                //
                //     switch (cat_level) {
                //         case 1:
                //             if (cat_id != cat1) {
                //                 page = 1;
                //             }
                //             cat1 = cat_id;
                //             cat2 = '';
                //             cat3 = '';
                //             break;
                //         case 2:
                //             if (cat_id != cat2) {
                //                 page = 1;
                //             }
                //             cat2 = cat_id;
                //             cat3 = '';
                //             break;
                //         case 3:
                //             if (cat_id != cat3) {
                //                 page = 1;
                //             }
                //             cat3 = cat_id;
                //             break;
                //         default:
                //             break;
                //     }
                //
                //     var fd = new FormData($('#form_item')[0]);
                //     fd.append('ajax_action', 'datasheet-open');
                //     fd.append('cat_id', cat_id);
                //     fd.append('cat1', cat1);
                //     fd.append('cat2', cat2);
                //     fd.append('cat3', cat3);
                //     fd.append('page', page);
                //
                //     $.ajax({
                //         type: "POST",
                //         dataType: 'json',
                //         data: fd,
                //         contentType: false,
                //         processData: false,
                //         success: function (response) {
                //             if (response.validation) {
                //                 $('.datasheet-results').html(response.template);
                //                 //window.location.href = response.redirect;
                //             } else {
                //                 goToByScroll('form_item');
                //             }
                //         },
                //         error: function (response, status, error) {
                //             console.log('Si &egrave; verificato un errore! Riprova');
                //         }
                //     });
                // });
                //
                // $(".ds-request-btn").click(function(e) {
                //     e.preventDefault();
                //     var $btn = $(this),
                //         postId = $btn.attr("data-id");
                //
                //     $btn.prop("disabled", true);
                //     $.post(
                //         '/datasheets/requests',
                //         {
                //             "_token": $("meta[name='_token']").attr("content"),
                //             "id": postId,
                //             "action": "request"
                //         },
                //         function(response) {
                //             if ("success" in response && 1 === response.success) {
                //                 $btn.replaceWith($("<div>", {"class": "alert alert-success"}).text(datasheetRequestStatusLabels.requested));
                //             }
                //             else {
                //                 $btn.prop("disabled", false);
                //             }
                //         }
                //     );
                // });

                /*

                if (document.getElementById("category-panel")) {
                    var vueCategoryPanel = new Vue({
                        el: "#category-panel",
                        data: {
                            response: {
                                category: null,
                                subcategories: [],
                                parentCategory: null
                            }
                        },
                        mounted: function () {
                            this.getTopLevelCategories();
                        },
                        methods: {
                            getTopLevelCategories: function () {
                                $.getJSON("/datasheets/categories", null, function (response) {
                                    vueCategoryPanel.response = response;
                                    vueDatasheetResults.loadResultsWithCat();
                                });
                            },
                            gotoCategory: function (href) {
                                $.getJSON(href, null, function (response) {
                                    vueCategoryPanel.response = response;
                                    vueDatasheetResults.loadResultsWithCat(response.category.id);
                                });
                            },
                            gotoParentCategory: function () {
                                if (this.response.parentCategory) {
                                    this.gotoCategory(this.response.parentCategory.href);
                                } else {
                                    this.getTopLevelCategories();
                                }
                            }
                        }
                    });
                }

                if (document.getElementById("datasheet-results")) {
                    var vueDatasheetResults = new Vue({
                        el: "#datasheet-results",
                        data: {
                            searchText: null,
                            searchCat: null,
                            response: {
                                data: [],
                                links: {},
                                meta: {}
                            }
                        },
                        methods: {
                            loadResultsWithHref: function (href) {
                                $.getJSON(href, null, function (response) {
                                    vueDatasheetResults.response = response;
                                });
                            },
                            loadResultsWithCat: function (cat) {
                                this.searchCat = cat;
                                var href = "/datasheets",
                                    hasParams = false;
                                if ("string" === typeof this.searchText && this.searchText.length > 0) {
                                    if (!hasParams) {
                                        href += "?";
                                        hasParams = true;
                                    }
                                    href += "s=" + decodeURIComponent(this.searchText);
                                }
                                if ("number" === typeof cat) {
                                    if (hasParams) {
                                        href += "&";
                                    } else {
                                        href += "?";
                                        hasParams = true;
                                    }
                                    href += "cat=" + decodeURIComponent(cat);
                                }
                                this.loadResultsWithHref(href);
                            }
                        },
                        watch: {
                            searchText: function (newVal, oldVal) {
                                this.loadResultsWithCat(this.searchCat);
                            }
                        }
                    });
                }

                */

                $(document).on("click", "#category-panel a.category", function (e) {
                    e.preventDefault();
                    showBodyOverlay();
                    $("#datasheet-row-wrapper").load(
                        $(this).attr("href") + " .row.datasheet",
                        null,
                        hideBodyOverlay
                    );
                });

                $(".accept-request-btn").click(function (e) {
                    e.preventDefault();
                    var $btn = $(this),
                        requestId = $btn.attr("data-id"),
                        $a = $btn.parent(),
                        $message = $a.parent().next().next();
                    $btn.prop("disabled", true);
                    $message.empty();
                    $.post(
                        '/datasheets/requests',
                        {
                            "_token": $("meta[name='_token']").attr("content"),
                            "id": requestId,
                            "action": "accept"
                        },
                        function (response) {
                            if ("success" in response && 1 === response.success) {
                                $a.empty();
                                $message.prev().empty();
                                $message.show()
                                    .append(
                                        $("<div>").addClass("col-xs-12 margin-top-15 padding-15 alert-success").text(datasheetRequestStatusLabels.accepted)
                                    );
                            } else {
                                $btn.prop("disabled", false);
                                $message.show()
                                    .append(
                                        $("<div>").addClass("col-xs-12 alert alert-danger").text("errors" in response ? response.errors : "")
                                    );
                            }
                        }
                    );
                });
                // $(".refuse-request-btn").click(function(e) {
                //     e.preventDefault();
                //     var $btn = $(this),
                //         requestId = $btn.attr("data-id"),
                //         $a = $btn.parent().parent(),
                //         $message = $a.next();
                //
                //     $btn.prop("disabled", true);
                //     $message.empty();
                //     $.post(
                //         '/datasheets/requests',
                //         {
                //             "_token": $("meta[name='_token']").attr("content"),
                //             "id": requestId,
                //             "action": "refuse",
                //             "reason": $("#refuse-reason-input").val()
                //         },
                //         function(response) {
                //             if ("success" in response && 1 === response.success) {
                //                 $a.prev().children(".agent-action-row").empty();
                //                 $message.prev().empty();
                //                 $message.show()
                //                     .append(
                //                         $("<div>").addClass("col-xs-12 margin-top-15 padding-15 alert-success").text(datasheetRequestStatusLabels.refused)
                //                     );
                //             }
                //             else {
                //                 $btn.prop("disabled", false);
                //                 $message.show()
                //                     .append(
                //                         $("<div>").addClass("col-xs-12 margin-top-15 padding-15 alert-danger").text("errors" in response ? response.errors[0] : "")
                //                     );
                //             }
                //         }
                //     );
                // });
            }
        },

        'recipes': {
            init: function () {
                $("#favourite-recipes").collapse();
            }
        },

        'recipe_show': {
            init: function () {
                $("#dlg-ingredient-groups-submit").click(function () {
                    $("#dlg-ingredient-groups").modal("hide");
                    $("#dlg-ingredient-groups form").submit();
                });
            }
        },

        'recipe_catalogue': {
            init: function () {
                // var $body = $('body'),
                //     $open_mobile = $('span#open_mobile'),
                //     $close_mobile = $('span#close_mobile'),
                //     $recipecat_list = $('nav.recipe-cat-list');
                //
                // $close_mobile.click(function () {
                //     $body.toggleClass('open_cat');
                //     $recipecat_list.toggleClass('open_cat');
                // });
                // $open_mobile.click(function () {
                //     $body.toggleClass('open_cat');
                //     $recipecat_list.toggleClass('open_cat');
                // });
                //
                // function close_recipecat_list_on_mobile() {
                //     var win_w = $(window).innerWidth();
                //     if (win_w >= 768) {
                //         if ($body.hasClass('open_cat')) {
                //             $body.removeClass('open_cat');
                //         }
                //         if ($recipecat_list.hasClass('open_cat')) {
                //             $recipecat_list.removeClass('open_cat');
                //         }
                //     }
                // }
                //
                // close_recipecat_list_on_mobile();
                // $(window).resize(function () {
                //     close_recipecat_list_on_mobile();
                // });
                //
                // $('.datasheet-item').click(function (e) {
                //     e.preventDefault();
                //
                //     //Dati
                //     var cat_id = $(this).data('id');
                //     var fd = new FormData($('#form_item')[0]);
                //     fd.append('ajax_action', 'catalogue-open');
                //     fd.append('cat_id', cat_id);
                //
                //     $.ajax({
                //         type: "POST",
                //         dataType: 'json',
                //         data: fd,
                //         contentType: false,
                //         processData: false,
                //         success: function (response) {
                //             if (response.validation) {
                //                 $('.recipe-cat-results').html(response.template);
                //                 //window.location.href = response.redirect;
                //             } else {
                //                 goToByScroll('form_item');
                //
                //             }
                //         },
                //         error: function (response, status, error) {
                //             console.log('Si &egrave; verificato un errore! Riprova');
                //         }
                //     });
                // });

                $(document).on("click", "#category-panel a.category", function (e) {
                    e.preventDefault();
                    showBodyOverlay();
                    $("#datasheet-row-wrapper").load(
                        $(this).attr("href") + " .row.datasheet",
                        null,
                        hideBodyOverlay
                    );
                });
            }
        },

        'recipe_addedit': {
            init: function () {
                var $body = $('body'),
                    $parenter = $('.panel-heading a'),
                    $expander = $('.icon-icon-FMC_webfont_add');

                $parenter.click(function () {
                    var $panel = $(this).parent().parent();
                    $panel.toggleClass('selected');
                    $panel.find('.selected').removeClass('selected');
                });
                $(document).on("click", ".icon-icon-FMC_webfont_add", function () {
                    $(this).toggleClass('selected');
                    var $to_expand = $(this).parent().next();
                    $to_expand.toggleClass('selected');
                });


                $('#btn-save').click(function (e) {
                    e.preventDefault();

                    //Dati
                    var fd = new FormData($('#form_item')[0]);
                    fd.append('ajax_action', 'recipe-save');

                    $.ajax({
                        type: "POST",
                        dataType: 'json',
                        data: fd,
                        contentType: false,
                        processData: false,
                        success: function (response) {
                            $('#box-add-success').hide();
                            $('#form_errors').html('');
                            if (response.validation) {
                                window.location.href = response.redirect;
                            } else {
                                $('#form_errors').html(response.template);
                                goToByScroll('form_errors');

                            }
                        },
                        error: function (response, status, error) {
                            console.log('Si &egrave; verificato un errore! Riprova');
                        }
                    });
                });

                $('.container').on("keyup", ".ingrediente-quantita", function (e) {
                    var typedValue = $(this).val(),
                        parsedValue = parseFloat(typedValue),
                        $confirmIcon = $(this).parent().next().find('.recipe-detail-addedit');
                    if (typedValue.length > 0) {
                        $confirmIcon.removeClass("empty");
                    } else {
                        $confirmIcon.addClass("empty");
                    }
                });

                function syncRecipeTotalWeight()
                {
                    $("#current-recipe-weight").text($("#recipe-total-weight").text());
                }

                $('.container').on("click", ".recipe-detail-addedit", function (e) {
                    e.preventDefault();

                    //Elimino l'eventuale box informativo
                    $('#box-add-success').hide();

                    //Dati
                    var detail_id = $(this).data('detail_id');
                    var ingredient_type = $(this).data('ingredient_type');
                    var ingredient_id = $(this).data('ingredient_id');
                    var qta = 0, costo = 0;
                    if (!detail_id) {
                        qta = $('#ingrediente-' + ingredient_type + '-' + ingredient_id).val();
                        costo = $('#costo-ingrediente-' + ingredient_type + '-' + ingredient_id).val();
                    } else {
                        qta = $('#modifica-ingrediente-' + detail_id).val();
                        costo = $('#modifica-costo-ingrediente-' + detail_id).val();
                    }

                    var fd = new FormData($('#form_item')[0]);
                    fd.append('ajax_action', 'recipe-detail-addedit');
                    fd.append('detail_id', detail_id);
                    fd.append('detail_qta', qta);
                    fd.append('detail_costo', costo);
                    fd.append('ingredient_type', ingredient_type);
                    fd.append('ingredient_id', ingredient_id);

                    $.ajax({
                        type: "POST",
                        dataType: 'json',
                        data: fd,
                        contentType: false,
                        processData: false,
                        success: function (response) {
                            $('#form_errors').html('');
                            if (response.validation) {
                                if (!detail_id) {
                                    $('#ingrediente-' + ingredient_type + '-' + ingredient_id).val('');
                                    $('.icon-icon-FMC_webfont_add').removeClass('selected');
                                    $('.aggiungi-ingrediente-quantita').removeClass('selected');
                                } else {
                                    $('#modifica-ingrediente-' + detail_id).val('');
                                    $('.single-recipe-ingredients-detail').removeClass('in');
                                }

                                $('#elenco-recipe-details').html(response.details);
                                $('#summary-recipe').html(response.summary);
                                syncRecipeTotalWeight();

                                if ("change_recipe_weight_ingredients" in response) {
                                    $("#change-recipe-weight-ingredient-id").html(response.change_recipe_weight_ingredients);
                                }                                

                            } else {
                                $('#form_errors').html(response.template);
                                goToByScroll('form_errors');

                            }
                        },
                        error: function (response, status, error) {
                            console.log('Si &egrave; verificato un errore! Riprova');
                        }
                    });
                });
                $('.container').on("click", ".recipe-detail-remove", function (e) {
                    e.preventDefault();

                    //Elimino l'eventuale box informativo
                    $('#box-add-success').hide();

                    //Dati
                    var detail_id = $(this).data('detail_id');


                    var fd = new FormData($('#form_item')[0]);
                    fd.append('ajax_action', 'recipe-detail-remove');
                    fd.append('detail_id', detail_id);

                    $.ajax({
                        type: "POST",
                        dataType: 'json',
                        data: fd,
                        contentType: false,
                        processData: false,
                        success: function (response) {
                            $('#form_errors').html('');
                            if (response.validation) {
                                $('#elenco-recipe-details').html(response.details);
                                $('#summary-recipe').html(response.summary);
                                syncRecipeTotalWeight();

                                if ("change_recipe_weight_ingredients" in response) {
                                    $("#change-recipe-weight-ingredient-id").html(response.change_recipe_weight_ingredients);
                                }                                

                            } else {
                                $('#form_errors').html(response.template);
                                goToByScroll('form_errors');

                            }
                        },
                        error: function (response, status, error) {
                            console.log('Si &egrave; verificato un errore! Riprova');
                        }
                    });
                });

                $(document).on("change", "#search-ingredients", function (e) {
                    e.preventDefault();
                    var queryString = escape($(this).val().trim());

                    showBodyOverlay();
                    $.get(
                        "//" + location.hostname + location.pathname,
                        {
                            search: queryString
                        },
                        function (responseText) {
                            hideBodyOverlay();
                            var $tmp = $(responseText);
                            $("section.aggiungi-ingrediente").html(
                                $tmp.find("#elenco-ingredienti").first()
                            );
                            var searchString = $("#search-ingredients").val().replace("%20", " ");
                            $("#search-ingredients").val(searchString);
                        }
                    );

                    return false;
                });

                $(document).on("keypress", "#search-ingredients", function (event) {
                    var keycode = (event.keyCode ? event.keyCode : event.which);
                    if(keycode === 13){
                        event.preventDefault();
                        $("#search-ingredients").change();
                    }
                });

                $(document).on("click", "#btn-reset-search-ingredients", function (e) {
                    e.preventDefault();
                    $("#search-ingredients").val('').change();
                    return false;
                });

                $("#agent-list").on("change", ".checkbox", function (e) {
                    var $cb = $(this);
                    if ($cb.hasClass("area-leader")) {
                        var checked = $cb.children("input").first().prop("checked");
                        $cb.parent().find(".checkbox.agent input").prop("checked", checked);
                    }
                });


                // modal per aggiunta utenti


                window.tmpUserList = {};
                $(".choose-user-modal").on("change", "input[type='checkbox']", function (e) {
                    var $this = $(this),
                        userType = $this.data("type"),
                        id = $this.val(),
                        fullname = $this.next("label").text(),
                        $sublist = $this.next("label").next("ul");

                    if (e.target.checked) {
                        tmpUserList[userType][id] = fullname;
                        if ($sublist.length > 0) {
                            $sublist.find("input[type='checkbox']").each(function () {
                                var $agentCkb = $(this),
                                    agentId = $agentCkb.val(),
                                    agentFullName = $agentCkb.next("label").text();
                                $agentCkb.prop("checked", true);
                                tmpUserList.agent[agentId] = agentFullName;
                            });
                        }
                    } else {
                        delete (tmpUserList[userType][id]);
                        if ($sublist.length > 0) {
                            $sublist.find("input[type='checkbox']").each(function () {
                                var $agentCkb = $(this),
                                    agentId = $agentCkb.val();
                                $agentCkb.prop("checked", false);
                                delete tmpUserList.agent[agentId];
                            });
                        }
                    }
                });

                var loadingUsers = false;
                var searchForUsers = function ($searchInput, prevOrNextUrl) {
                    if (loadingUsers) {
                        return;
                    }
                    loadingUsers = true;
                    var nameToSearch = $searchInput.val().trim(),
                        userType = $searchInput.data("type");
                    $.get(
                        prevOrNextUrl ? prevOrNextUrl : '/search_user',
                        prevOrNextUrl ? {} : {
                            'type': userType,
                            'name': nameToSearch,
                            'page': 1
                        },
                        function (response) {
                            var userList = response.data;
                            var $tmp = $("<ul>"),
                                $row = null,
                                $input = null,
                                inputId = '',
                                $label = null;

                            for (var i = 0, userListLength = userList.length; i < userListLength; i++) {
                                var userListItem = userList[i];
                                $row = $("<li>", {"class": "checkbox"});
                                inputId = "modal-user-" + userType + "-" + String(userListItem.id);
                                $input = $("<input>", {
                                    "type": "checkbox",
                                    "value": userListItem.id,
                                    "id": inputId,
                                    "data-type": userType
                                }).prop("checked", userListItem.id in tmpUserList[userType]);
                                $row.append($input);
                                $label = $("<label>", {"for": inputId}).text(userListItem.fullname);
                                $row.append($label);
                                if ('area_leader' === userType && "agents" in userListItem) {
                                    var agentList = userListItem.agents,
                                        agentListLength = agentList.length;
                                    if (agentListLength > 0) {
                                        var $agentUl = $("<ul>");
                                        for (var k = 0, agent = null; k < agentListLength; k++) {
                                            agent = agentList[k];
                                            var agentInputId = "modal-user-agent-" + String(agent.id);
                                            $agentUl.append(
                                                $("<li>", {"class": "checkbox"}).append(
                                                    $("<input>", {
                                                        "type": "checkbox",
                                                        "value": agent.id,
                                                        "id": agentInputId,
                                                        "data-type": "agent"
                                                    })
                                                        .prop("checked", agent.id in tmpUserList.agent)
                                                ).append(
                                                    $("<label>", {"for": agentInputId}).text(agent.fullname)
                                                )
                                            );

                                            // relazione capoarea(userListItem.id) -> agenti(agent.id)
                                            var areaLeaderAgentsIds = tmpUserList.arealeaders_agents[userListItem.id] || [],
                                                agentId = parseInt(agent.id);
                                            if (areaLeaderAgentsIds.indexOf(agentId)) {
                                                areaLeaderAgentsIds.push(agentId);
                                                tmpUserList.arealeaders_agents[userListItem.id] = areaLeaderAgentsIds;
                                            }
                                        }
                                        $row.append($agentUl);
                                    }
                                }
                                $tmp.append($row);
                            }
                            $searchInput.parent().next().empty().append($tmp.children());
                            // paginazione
                            var $pagination = $searchInput.parent().parent().find('.pagination').first(),
                                $paginationPrev = $pagination.children(".pagination-prev").first(),
                                $paginationPrevLink = $paginationPrev.children(".pagination-prev-link").first(),
                                $paginationNext = $pagination.children(".pagination-next").first(),
                                $paginationNextLink = $paginationNext.children(".pagination-next-link").first();

                            if (response.prev_page_url) {
                                $paginationPrev.show();
                                $paginationPrevLink.attr("href", response.prev_page_url).off("click").on("click", function (e) {
                                    e.preventDefault();
                                    searchForUsers($searchInput, $(this).attr("href"));
                                    return false;
                                });
                            } else {
                                $paginationPrev.hide();
                                $paginationPrevLink.attr("href", "#");
                            }
                            if (response.next_page_url) {
                                $paginationNext.show();
                                $paginationNextLink.attr("href", response.next_page_url).off("click").on("click", function (e) {
                                    e.preventDefault();
                                    searchForUsers($searchInput, $(this).attr("href"));
                                    return false;
                                });
                            } else {
                                $paginationNext.hide();
                                $paginationNextLink.attr("href", "#");
                            }

                            loadingUsers = false;
                        }
                    );
                };

                // apertura modal
                $(".choose-user-modal").on("show.bs.modal", function () {
                    var $modal = $(this),
                        userType = $modal.data("type"),
                        listId = $modal.data("listid"),
                        checkboxName = $modal.data("checkboxname"),
                        $searchInput = $modal.find('input[name="choose-user-modal-name"]').first();

                    if (!(userType in tmpUserList)) {
                        tmpUserList[userType] = {};
                    }
                    if ("area_leader" === userType) {
                        if (!("agent" in tmpUserList)) {
                            tmpUserList.agent = {};
                        }
                        if (!("arealeaders_agents" in tmpUserList)) {
                            tmpUserList.arealeaders_agents = {};
                            // utilizzato solo per sapere a quale capoarea corrisponde un agente
                        }
                    }
                    // guardo quelli già selezionati sulla pagina
                    $("#" + listId).find(".recipe-user-" + userType).each(function () {
                        var $ckb = $(this),
                            id = String($ckb.val()),
                            fullname = $ckb.next("label").text();
                        tmpUserList[userType][id] = fullname;
                        if ("area_leader" === userType) {
                            $("#" + listId).find(".recipe-user-agent").each(function () {
                                var $ckbAgent = $(this),
                                    agentId = parseInt($ckbAgent.val()),
                                    agentFullname = $ckbAgent.next("label").text();
                                tmpUserList.agent[agentId] = agentFullname;

                                // relazione capoarea(id) -> agenti(agentId)
                                var areaLeaderAgentsIds = tmpUserList.arealeaders_agents[id] || [];
                                if (areaLeaderAgentsIds.indexOf(agentId)) {
                                    areaLeaderAgentsIds.push(agentId);
                                    tmpUserList.arealeaders_agents[id] = areaLeaderAgentsIds;
                                }
                            });
                        }
                    });

                    $searchInput.change();
                });
                // cerca utenti
                $('.choose-user-modal input[name="choose-user-modal-name"]').change(function () {
                    searchForUsers($(this), null);
                });
                // salva => aggiunge gli utenti selezionati nella pagina
                $(".choose-user-modal .save-btn").click(function (e) {
                    var $this = $(this),
                        $modal = $this.parentsUntil(".choose-user-modal").parent(),
                        userType = $modal.data("type"),
                        usersToAdd = tmpUserList[userType],
                        listId = $modal.data("listid"),
                        checkboxName = $modal.data("checkboxname"),
                        $tmp = $("<ul>");
                    for (var id in usersToAdd) {
                        if (usersToAdd.hasOwnProperty(id)) {
                            var fullname = usersToAdd[id],
                                checkboxId = userType + "-" + String(id),
                                $checkbox = $("<input>", {
                                    "type": "checkbox",
                                    "id": checkboxId,
                                    "name": checkboxName
                                }).val(id).prop("checked", true),
                                $label = $("<label>", {"for": checkboxId}).text(fullname),
                                $div = $("<div>", {"class": "checkbox"}),
                                $li = $("<li>", {"class": "user-list-item"});
                            $div.append($checkbox).append($label);
                            $li.append($div);

                            if ("area_leader" === userType) {
                                var areaLeaderAgents = tmpUserList.arealeaders_agents[id] || [],
                                    n = areaLeaderAgents.length;
                                if (n > 0) {
                                    var $agentUl = $("<ul>");
                                    for (var i = 0; i < n; i++) {
                                        var agentId = areaLeaderAgents[i];
                                        if (agentId in tmpUserList.agent) { // è stato selezionato
                                            var agentFullname = tmpUserList.agent[agentId],
                                                agentInputId = "agent-" + String(agentId);
                                            $agentUl.append(
                                                $("<li>", {"class": "checkbox"}).append(
                                                    $("<input>", {
                                                        "type": "checkbox",
                                                        "name": "agents_selected[]",
                                                        "value": agentId,
                                                        "id": agentInputId,
                                                        "data-type": "agent"
                                                    })
                                                        .prop("checked", true)
                                                ).append(
                                                    $("<label>", {"for": agentInputId}).text(agentFullname)
                                                )
                                            );
                                        }
                                    }
                                    $li.append($agentUl);
                                }
                            }
                            $tmp.append($li);
                        }
                    }
                    var $list = $("#" + listId);
                    $list.children(".user-list-item").remove();
                    $list.prepend($tmp.children());
                    $modal.modal("hide");
                });

            }
        },

        'demo_request_new': {
            init: function () {
                $("#request_type_select").change(function () {
                    switch ($(this).val()) {
                        case 'intervento_tecnico':
                            $("#demo_request_row_samples").hide();
                            $("#demo_request_row_technician").show();
                            break;
                        case 'invio_campioni':
                            $("#demo_request_row_samples").show();
                            $("#demo_request_row_technician").hide();
                            break;
                        case 'intervento_e_campioni':
                            $("#demo_request_row_samples").show();
                            $("#demo_request_row_technician").show();
                            break;
                    }
                });

                $("select[name=demo_type]").change(function () {
                    if ("demo_presso_cliente" === $(this).val()) {
                        $("#demo_site_hint").show();
                    } else {
                        $("#demo_site_hint").hide();
                    }
                });

                $(".demo-request-search-modal").on("show.bs.modal", function () {
                    $(this).find("input[type=search]").val("");
                });
                $(".demo-request-search-modal .search-input").change(function (e) {
                    e.preventDefault();
                    e.stopPropagation();
                    var $modal = $(this).parentsUntil('.demo-request-search-modal').parent(),
                        codeToSearch = $(this).val(),
                        typeToSearch = $(this).data("type"),
                        $noResult = $modal.find(".no-result");
                    $noResult.hide();
                    $.get(searchUrl, {
                            'type': typeToSearch,
                            'code': codeToSearch
                        },
                        function (response) {
                            var $listGroup = $modal.find(".list-group");
                            $listGroup.empty();
                            window.tmpSearchResults = null;
                            if ($.isArray(response)) {

                                // window.tmpSearchResults = Object.assign([], response); // non funziona su IE
                                window.tmpSearchResults = [].concat(response);

                                if (response.length > 0) {
                                    $.each(response, function (i, e) {
                                        $listGroup.append(
                                            $("<a>", {
                                                href: "#",
                                                class: "list-group-item list-group-item-action",
                                                "data-i": i
                                            }).html([e.code, e.name].join(" "))
                                        );
                                    });
                                } else {
                                    $noResult.show();
                                }
                            } else {
                                $noResult.show();
                            }
                        });
                    return false;
                });

                $("#search-modal-customer").on("click", ".list-group a", function (e) {
                    e.preventDefault();
                    var dataI = parseInt($(this).data("i"));
                    if (!isNaN(dataI)) {
                        var customerData = window.tmpSearchResults[dataI];
                        $("input[name='customer_id']").val(customerData.id);
                        $("#customer-selected").html([
                            customerData.code,
                            customerData.name,
                            customerData.address
                        ].join("<br>"));
                        $("#search-modal-customer").modal("hide");

                        // se ho scelto la tipologia "Demo presso cliente" riempo la casella dell'indirizzo
                        if ("demo_presso_cliente" === $("select[name=demo_type]").val()) {
                            $("input[name=demo_site]").val(customerData.address);
                        }
                    }
                    return false;
                });

                var buildProductRow = function (productData) {
                    var $listGroupItem = $("<li>", {class: "list-group-item"}),
                        h = '<div class="row no-margin">' +
                            '        <div class="col-xs-12 col-md-6 no-padding">' +
                            '            <span>' + [productData.code, productData.name].join(" ") + '</span>' +
                            '        </div>\n' +
                            '        <div class="col-xs-12 col-md-6 no-padding">' +
                            '            <div class="row no-margin">' +
                            '                <div class="col-xs-8 no-padding-left">' +
                            '                    <input type="number" min="0" name="product_qty[]" value="" placeholder="' + labels.qta + '" class="form-control pull-right full-width">' +
                            '                </div>' +
                            '                <div class="col-xs-4 no-padding">' +
                            '                    <select name="product_um[]">' +
                            '                       <option value="CT">CT</option>' +
                            '                       <option value="PZ">PZ</option>' +
                            '                    </select>' +
                            '                </div>' +
                            '            </div>' +
                            '        </div>' +
                            '    </div>' +
                            '    <div class="row no-margin">' +
                            '        <div class="col-xs-12 no-padding">' +
                            '            <button type="button" class="pull-right margin-top-15">' + labels.elimina + '</button>' +
                            '            <input type="hidden" name="product_code[]" value="' + productData.code + '">' +
                            '            <input type="hidden" name="product_name[]" value="' + productData.name + '">' +
                            '        </div>' +
                            '    </div>';

                    $listGroupItem.append(h);
                    return $listGroupItem;
                };

                $("#search-modal-product").on("click", ".list-group a", function (e) {
                    e.preventDefault();
                    var dataI = parseInt($(this).data("i"));
                    if (!isNaN(dataI)) {
                        var productData = window.tmpSearchResults[dataI];
                        $("#product-list").append(buildProductRow(productData));
                        $("#search-modal-product").modal("hide");
                    }
                    return false;
                });

                $("#product-list").on("click", ".list-group-item button", function () {
                    var $listGroupItem = $(this).parentsUntil(".list-group-item").parent();
                    $listGroupItem.remove();
                });

            }
        },

        'base_properties':  {
            init: function () {
                $("#form-filters select").on("change", function () {
                    $("#form-filters").trigger("submit");
                });
            },
            finalize: function () {

            }
        }
    };

    // The routing fires all common scripts, followed by the page specific scripts.
    // Add additional events for more control over timing e.g. a finalize event
    var UTIL = {
        fire: function (func, funcname, args) {
            var fire;
            var namespace = Sage;
            funcname = (funcname === undefined) ? 'init' : funcname;
            fire = func !== '';
            fire = fire && namespace[func];
            fire = fire && typeof namespace[func][funcname] === 'function';

            if (fire) {
                namespace[func][funcname](args);
            }
        },
        loadEvents: function () {
            // Fire common init JS
            UTIL.fire('common');

            // Fire page-specific init JS, and then finalize JS
            $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function (i, classnm) {
                UTIL.fire(classnm);
                UTIL.fire(classnm, 'finalize');
            });

            // Fire common finalize JS
            UTIL.fire('common', 'finalize');
        }
    };

    // Load Events
    $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
